const p = (...args) => {
  const flag = localStorage.getItem('__DEV__');

  if (flag) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export default {
  p,
};
